import type { EditorKind, EditorNode } from "./mapEdit.js";

const CASE_ICONS = {
  small: "/icon-case-small.png",
  medium: "/icon-case-medium.png",
  large: "/icon-case-large.png",
  boss: "/icon-boss.png",
} as const;

const KIND_ICONS: Record<Exclude<EditorKind, "case">, string> = {
  start: "/icon-start.png",
  rest: "/icon-rest.png",
  event: "/icon-event.png",
  relic: "/icon-relic-v2.png",
};

export function editorIcon(node: EditorNode): string {
  return node.kind === "case" ? CASE_ICONS[node.size] : KIND_ICONS[node.kind];
}

export function kindIcon(kind: EditorKind): string {
  return kind === "case" ? CASE_ICONS.small : KIND_ICONS[kind];
}
